<template>
<div>    
   <br v-if="!isMobile"> <br> <br> 
  <div class="container"> 
    <center><img :src="isMobile ? 'https://gestionprueba.asistentemovistar.com.mx/banner_movil.png' : 'https://gestionprueba.asistentemovistar.com.mx/banner.png'" class="rounded" alt="Image" :width="isMobile ? '350' : '900'"></center> 
    <form @submit="login">
        <div class="text-center"> 
            <div class="row justify-content-center mt-5"> 
                <div class="col-md-4 mt-4">
                    <br>
                    <b-form-input placeholder="Correo"  v-model="email" class="form-control form-control-lg"  type="text" style="border-radius: 30px; background: transparent; border: 2px solid #ccc; font-size: 17px;"/>
                    <small v-if="errors && errors['email']" class="text-danger mt-2">
                        <i class="fas fa-exclamation-circle"></i>
                        Este campo es obligatorio
                    </small>
                    <br>
                    <b-form-input placeholder="MRT" v-model="mrt"  type="text" class="form-control form-control-lg"  style="border-radius: 30px; background: transparent; border: 2px solid #ccc; font-size: 17px;"/>
                    <small v-if="errors && errors['mrt']" class="text-danger mt-2 text-left" >
                        <i class="fas fa-exclamation-circle"></i>
                        Este campo es obligatorio
                    </small>
                </div>
                <div class="col-md-12">
                    <p v-if="errors && errors['general']" class="mt-4 lead text-danger">
                        <i class="fas fa-exclamation-circle"></i>
                        Datos incorrectos
                      </p>
                </div>
                <div class="col-md-7 mt-5 text-center">
                    <br><br>
                    <button :disabled="loader" class="btn btn-success float-center btn-sm" type="submit" :style="isMobile ? 'border-radius: 26px; width: 50%;' : 'border-radius: 26px; width: 30%; background:#5CB615; border-color:#5CB615;'">
                        <span v-if="!loader">
                            Acceder
                        </span>
                        <span v-else>
                        <b-spinner small></b-spinner> Accediendo...
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </form>
  </div>
  <br><br><template v-if="!isMobile"><br><br><br><br><br></template>
  <!-- <div>
    <div class="row justify-content-center">
        <div class="col-md-4"></div>
        <div class="col-md-3"></div>
        <div class="col-md-5">
            <div class="d-flex">
                <button :class="but == 1 ? 'btn btn-success' : 'btn btn-primary'" @click="butAccion(1)" v-if="perfil == 'Lider'">
                   <i class="far fa-plus"></i> Nueva Activación 
                </button>
                <button :class="but == 2 ? 'btn btn-success ml-3' : 'btn btn-primary ml-3' " @click="butAccion(2)">
                   <i class="far fa-list"></i> Activaciones
                </button>
            </div>
        </div>
    </div>
    <section class="mt-3">
        <b-carousel :interval="4000"
                    background="#ababab">
          <b-carousel-slide img-src="https://asistentemovistar.com.mx/activacion/bienvenido.jpg">
          </b-carousel-slide>
        </b-carousel>
    </section>
    <br><br>
    <template v-if="but == 1">
       
    </template>
    <template v-else>
     
    </template>
    
  </div> -->
</div>
</template>

<script>
// import LogoSVG from "../../layouts/LogoSVG.vue";
// import NavbarPF from "../activaciones/NavActivacion.vue";
// import Registro from "../activaciones/Registro.vue";
// import Listado from "../activaciones/Listado.vue";
// import InitController from "@/utils/InitController";
import Cookies from "js-cookie";
// import Swal from 'sweetalert2' 
export default {
    name:"Activaciones",
    // components: {
    //     LogoSVG,
    //     NavbarPF,
    //     Registro,
    //     Listado
    // },
    data() {
        return {
          errors:[],
          loader:false,
          email:"",
          mrt:"",
          isMobile: this.$mobile(),
        }
    },
    methods:{
        login(e) {
            e.preventDefault();
            this.errors = [];
            this.loader = true;
            var form = {}; 

                form.mrt = this.mrt
                form.email = this.email 

            this.$api.post('auth/login_gestor', form, true).then(({data}) => {
                console.log(data.data); 
                this.$store.dispatch("setLogin", data.data);
                this.$router.push("/");
                this.loader = false; 
            }).catch(e => {
                console.log(e);
                this.loader = false;
                if (e.response.data.errors) {
                    this.errors = e.response.data.errors;
                } else {
                  alert("Ocurrió un error desconocido, vuelve a intentarlo más tarde")
                }
            });
        },
        cerrarSesion(){
            this.$store.commit(
                "setLoginStatus",
                false
            );
            this.$store.commit(
                "setInfoUser",
                null
            );    
            Cookies.remove("session_id");
            location.reload();
        },
    }
}
</script>

<style>

</style>